import { customerGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import * as z from "zod";

export const fetchSegmentById = {
  name: "fetchSegmentById" as const,
  mutates: false,
  input: z.string(),
  output: customerGroupSchema,
};
